import http from 'src/services/http'

export const fetchDeclineReasons = async() => {
  const response = await http('admin/declineReasons', {
    method: 'GET',
  })
  return response?.data
}

